import * as yup from "yup";

export default yup.object().shape({
    content: yup.string().required(),
});
